export class TeamQueueEdit {
  queue: Array<TeamQueueEditAbstractInformation>

  constructor() {
    this.queue = new Array<TeamQueueEditAbstractInformation>()
  }
}

export class TeamQueueEditAbstractInformation {
  numberInGroup: number
  title: string
  abstractGroupIds: number[]
  sorting: number
  canBeRemoved: boolean // If an abstract or abstract group is currently being coded, it cannot be removed
}
